import React, { useState, useEffect, useCallback } from "react";
import Header from "../components/Header";
import "../assets/CSS/Dashboard.css";
import axiosInstance from "../axiosConfig";
import Sidebar from "../components/Sidebar";
import DataTable from "react-data-table-component";

function RemarksSupervisor() {
  // const user = JSON.parse(localStorage.getItem("user")); // Get logged-in user data
  const [remarks, setRemarks] = useState([]); // All remarks
  const [filteredRemarks, setFilteredRemarks] = useState([]); // Filtered remarks
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [showModal, setShowModal] = useState(false); // Modal state
  const [showUpdateModal, setShowUpdateModal] = useState(false); // Update modal state
  const [selectedRow, setSelectedRow] = useState(null); // Selected row for update
  const [departments, setDepartments] = useState([]); // Departments for dropdown
  const [filters, setFilters] = useState({
    searchQuery: "",
    fromDate: "",
    toDate: "",
  });

  const initialFormData = {
    Responsible_Person: "", 
    Department: "",
    
  };

  const [formData, setFormData] = useState(initialFormData);

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  const user = JSON.parse(localStorage.getItem("userData")); // make sure it's loaded

//   // Fetch all remarks for the logged-in user
//   const fetchRemarks = useCallback(async () => {
//     try {
//       const response = await axiosInstance.get("/api/remarks");
//       // const userRemarks = response.data.filter(
//       //   (remark) => remark.Responsible_Person === user?.Name // Filter by logged-in user's name
//       // );
//       // setRemarks(userRemarks);
//       // setFilteredRemarks(userRemarks);
//       setRemarks(response.data); // Set all remarks
//       // setFilteredRemarks(userRemarks); // Initialize filtered remarks
//     } catch (error) {
//       console.error("Error fetching remarks:", error);
//     //   alert("Failed to fetch remarks.");
//     }
//   }, []); // user?.Name

  const fetchRemarks = useCallback(async () => {
  try {
    const response = await axiosInstance.get("/api/remarks");

    const userRemarks = response.data.filter(
      (remark) => remark.CreatedBy === user?.Name
    );

    setRemarks(userRemarks);
  } catch (error) {
    console.error("Error fetching remarks:", error);
  }
}, [user?.Name]);

    // Fetch departments
  const fetchDepartments = useCallback(async () => {
    try {
      const response = await axiosInstance.get("/api/departments");
      setDepartments(response.data);
    } catch (error) {
      console.error("Error fetching departments:", error);
      alert("Failed to fetch departments.");
    }
  }, []);

  useEffect(() => {
    fetchRemarks();

    fetchDepartments();
  }, [fetchRemarks, fetchDepartments]);

  // Handle input changes for filters
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Apply filters (search and date range)
  useEffect(() => {
    const { searchQuery, fromDate, toDate } = filters;

    const filtered = remarks.filter((remark) => {
      const remarkDate = new Date(remark.RemarkDate);

      const matchesSearch =
        searchQuery === "" ||
        [
          remark.Responsible_Person,
          remark.Department,
        ]
          .join(" ")
          .toLowerCase()
          .includes(searchQuery.toLowerCase());

      const matchesDate =
        (fromDate === "" || remarkDate >= new Date(fromDate)) &&
        (toDate === "" || remarkDate <= new Date(toDate));

      return matchesSearch && matchesDate;
    });

    setFilteredRemarks(filtered);
  }, [filters, remarks]);

  // Handle Input Changes for Modal Form
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const showAlert = (message, type) => {
    const alertPlaceholder = document.getElementById("alertPlaceholder");
    const alertHTML = `
      <div class="alert alert-${type} alert-dismissible fade show" role="alert">
        <strong>${
          type === "success" ? "Success!" : "Error!"
        }</strong> ${message}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>`;
    alertPlaceholder.innerHTML = alertHTML;
    setTimeout(() => {
      alertPlaceholder.innerHTML = "";
    }, 2000);
  };


  // Clear form data and close modal
  const resetFormAndCloseModal = (closeModalCallback) => {
    setFormData(initialFormData);
    closeModalCallback();
  };

  
  // Submit New Remark
  const handleFormSubmit = async (e) => {
    e.preventDefault();

     const payload = {
        ...formData,
        CreatedBy: user?.Name || "Unknown", // 👈 add creator name
     };
    // const dataToSend = { ...formData, Subject: "Under Capacity" };
    try {
      await axiosInstance.post("/api/remarks", payload);
      showAlert("Remark added successfully!", "success");
      resetFormAndCloseModal(() => setShowModal(false));
      fetchRemarks(); // Refresh remarks after creation
    } catch (error) {
      console.error("Error creating remark:", error);
      showAlert("Failed to create remark.", "danger");
    }
  };

  // Handle Update Form Submit
  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    if (!selectedRow) {
      showAlert("No row selected for update!",);
      return;
    }

    // const dataToSend = { ...formData, Subject: "Under Capacity" };
    try {
        await axiosInstance.put(`/api/remarks/${selectedRow.ID}`, {
      ...formData,
      UpdatedBy: user?.Name || "Unknown"
    });// Update the remark
      showAlert("Remark updated successfully!", "success");
      setShowUpdateModal(false); // Close the modal
      resetFormAndCloseModal(() => setShowUpdateModal(false));
      fetchRemarks(); // Refresh remarks after update

    } catch (error) {
    //   console.error("Error updating remark:", error);
      showAlert("Failed to update remark.", "danger");
    }
  };


  // Delete a Remark
  const deleteRemark = async (id) => {
    if (!window.confirm("Are you sure you want to delete this remark?")) return;

    try {
      await axiosInstance.delete(`/api/remarks/${id}`);
      showAlert("Remark deleted successfully!", "success");
      fetchRemarks(); // Refresh remarks after deletion
    } catch (error) {
      console.error("Error deleting remark:", error);
      showAlert("Failed to delete remark.", "danger");
    }
  };

  // Columns for the DataTable
  const columns = [
     {
      name: "Remark Date", width:"150px",
      selector: (row) => row.RemarkDate,
      sortable: true,
    },
    {
      name: "Responsible Person",
      selector: (row) => (
        <span data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={row.Responsible_Person}>

        {row.Responsible_Person}
        </span>
      ),
    
      sortable: true,
    },
   {
      name: "Department", width:"150px",
      selector: (row) => (
      <span
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={row.Department}>
        {row.Department}
      </span>),       
      sortable: true,
    },
    {
      name: "LOT ID",
      selector: (row) => row.LOT_ID,
      sortable: true,
    },
    {
      name: "ProcessName",
      selector: (row) => row.ProcessName,
      sortable: true,
    },
  {
      name: "Parameters",
      selector: (row) => (
        <span
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={row.Parameters}>
        {row.Parameters}
      </span>),
      sortable: true,
    },
    {
      name: "DetailedIssue",width:"150px",
      selector: (row) => (
        <span data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={row.DetailedIssue}>

        {row.DetailedIssue}
        </span>
      ),
    //   row.Remark,
      sortable: false,
    },
    {
      name: "ApprovedBy",
      selector: (row) => row.ApprovedBy || "N/A",
      sortable: true,
    },
    {
  name: "Status",
  width: "100px",
  selector: (row) => row.Status || "N/A",
  sortable: true,
  cell: (row) => {
    const status = row.Status || "N/A";
    let bgColor = "transparent";
    let textColor = "black";
    let textbold = "normal";       // ← initialize here

    if (status === "Approved") {
      bgColor = "green";
      textColor = "white";
      textbold = "bold";  
    } else if (status === "Pending") {
      bgColor = "#fff3cd";
      textColor = "#856404";
      textbold = "bold";          // now this will work
    }

    return (
      <span
        style={{
          backgroundColor: bgColor,
          color: textColor,
          borderRadius: "4px",
          display: "inline-block",
          padding: "2px 2px",
          minWidth: "60px",
          textAlign: "center",
          fontWeight: textbold,    // uses the declared variable
        }}
      >
        {status}
      </span>
    );
  },
},

    {
      name: "Actions",
      cell: (row) => (
        <button
          className="btn btn-danger btn-sm"
          onClick={() => deleteRemark(row.ID)}
        >
          Delete
        </button>
      ),
      ignoreRowClick: false,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div className="d-flex dashboard">
      <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>
      <div className="flex-grow-1">
        <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
        <main className="main-container p-4" style={{ height: "fit-content" }}>
          <div className="container mt-0">
            <div className="d-flex justify-content-between align-items-center">
              <h3 className="mb-5">Remarks</h3>
              <div className="d-flex gap-2">
              <button
                className="btn btn-primary"
                onClick={() => setShowModal(true)}
              >
                Add Remark
              </button>
              <button
                  className="btn btn-primary"
                  style={{display:"none"}}
                  onClick={() => {
                    if (selectedRow) {
                      setFormData(selectedRow); // Populate the update form with selected row data
                      setShowUpdateModal(true); // Open update modal
                    } else {
                      showAlert("Please select a row to update!", "danger");
                    }
                  }}
                >
                  Update Remark
                </button>
                </div>
            </div>

            {/* Filter Section */}
            <input
                  type="text"
                  name="searchQuery"
                  value={filters.searchQuery}
                  onChange={handleFilterChange}
                  className="form-control me-2 mb-3"
                  style={{ width: "auto" }}
                  placeholder="Search..."
                />

            {/* DataTable */}
            <DataTable
              columns={columns}
              data={filteredRemarks}
              pagination
              selectableRows
              onSelectedRowsChange={(selected) => {
                setSelectedRow(selected.selectedRows[0] || null); // Set the selected row
              }}
            />
          </div>
        </main>
      </div>

      {/* Add Remark Modal */}
      {showModal && (
        <div className="modal show" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Remark</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => resetFormAndCloseModal(() => setShowModal(false))}
                ></button>
              </div>
              <form onSubmit={handleFormSubmit}>
                <div className="modal-body">
                  {/* <div className="mb-3">
                    <label className="form-label">Supervisor Name</label>
                    <input
                      type="text"
                      name="Responsible_Person"
                      placeholder="Enter Supervisor Name"
                      value={formData.Responsible_Person}
                      onChange={handleFormChange}
                      className="form-control"
                      
                    />
                  </div> */}
                  <div className="mb-3">
                    <label className="form-label">Responsible Person</label>
                    <select
                      name="Responsible_Person"
                      value={formData.Responsible_Person}
                      onChange={handleFormChange}
                      className="form-control"
                      required
                    >
                     <option value="">Select Responsible Person</option>
                      <option value="Khalid Qureshi">Khalid Qureshi</option>
                      <option value="VARUN">VARUN</option>
                      <option value="MONU ADMIN">MONU ADMIN</option>
                      <option value="SARFRAZ ADMIN">SARFRAZ ADMIN</option>
                      <option value="Ashwini">Ashwini</option>
                      <option value="SHOAIB">SHOAIB</option>
                    </select>
                  </div>
               
                  <div className="mb-3">
                    <label className="form-label">Department</label>
                    <select
                      name="Department"
                      value={formData.Department}
                      onChange={handleFormChange}
                      className="form-control"
                      required
                    >
                      <option value="">Select Department</option>
                      {departments.map((dept, index) => (
                            <option key={index} value={dept}>
                              {dept}
                            </option>
                      ))}
                    </select>
                  </div>
                   <div className="mb-3">
                    <label className="form-label">Parameters</label>
                    <select
                      name="Parameters"
                      value={formData.Parameters}
                      onChange={handleFormChange}
                      className="form-control"
                      required
                    >
                      <option value="">Select Parameters</option>
                      <option value="No Raw Material">No Raw Material</option>
                        <option value="Raw Material Quality Issue">Raw Material Quality Issue</option>
                      <option value="Quality Issue Delay">Quality Issue Delay</option>
                        <option value="Red Process">Red Process</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">LOT_ID</label>
                    <input
                      type="text"
                      name="LOT_ID"
                      value={formData.LOT_ID}
                      onChange={handleFormChange}
                      className="form-control"
                      placeholder="Enter LOT_ID"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">ProcessName</label>
                    <input
                      type="text"
                      name="ProcessName"
                      value={formData.ProcessName}
                      onChange={handleFormChange}
                      className="form-control"
                      placeholder="Enter Process Name"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Detailed Issue</label>
                    <textarea
                      name="DetailedIssue"
                      value={formData.DetailedIssue}
                      onChange={handleFormChange}
                      className="form-control"
                      placeholder="Enter Detailed Issue"
                      rows="3"
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="submit" className="btn btn-primary">
                    Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() =>resetFormAndCloseModal(() => setShowModal(false))}
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Update Remark Modal */}
      {showUpdateModal && (
        <div className="modal show" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Update Remark</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => resetFormAndCloseModal(() => setShowUpdateModal(false))}
                ></button>
              </div>
              <form onSubmit={handleUpdateSubmit}>
              <div className="modal-body">
                 
                  <div className="mb-3">
                    <label className="form-label">Responsible Person</label>
                    <select
                      name="Responsible_Person"
                      value={formData.Responsible_Person}
                      onChange={handleFormChange}
                      className="form-control"
                      required
                    >
                      <option value="">Select Responsible Person</option>
                      <option value="Khalid Qureshi">Khalid Qureshi</option>
                      <option value="VARUN">VARUN</option>
                      <option value="MONU ADMIN">MONU ADMIN</option>
                      <option value="SARFRAZ ADMIN">SARFRAZ ADMIN</option>
                      <option value="Ashwini">Ashwini</option>
                      <option value="SHOAIB">SHOAIB</option>
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Department</label>
                    <select
                      name="Department"
                      value={formData.Department}
                      onChange={handleFormChange}
                      className="form-control"
                      required
                    >
                      <option value="">Select Department</option>
                      {departments.map((dept, index) => (
                            <option key={index} value={dept}>
                              {dept}
                            </option>
                      ))}
                    </select>
                  </div>
                   <div className="mb-3">
                    <label className="form-label">Parameters</label>
                    <select
                      name="Parameters"
                      value={formData.Parameters}
                      onChange={handleFormChange}
                      className="form-control"
                      required
                    >
                    <option value="">Select Parameters</option>
                      <option value="No Raw Material">No Raw Material</option>
                        <option value="Raw Material Quality Issue">Raw Material Quality Issue</option>
                      <option value="Quality Issue Delay">Quality Issue Delay</option>
                        <option value="Red Process">Red Process</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">LOT_ID</label>
                    <input
                      type="text"
                      name="LOT_ID"
                      value={formData.LOT_ID}
                      onChange={handleFormChange}
                      className="form-control"
                      placeholder="Enter LOT_ID"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">ProcessName</label>
                    <input
                      type="text"
                      name="ProcessName"
                      value={formData.ProcessName}
                      onChange={handleFormChange}
                      className="form-control"
                      placeholder="Enter Process Name"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Detailed Issue</label>
                    <textarea
                      name="DetailedIssue"
                      value={formData.DetailedIssue}
                      onChange={handleFormChange}
                      className="form-control"
                      placeholder="Enter Detailed Issue"
                      rows="3"
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="submit" className="btn btn-primary">
                    Update
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => resetFormAndCloseModal(() => setShowUpdateModal(false))}
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default RemarksSupervisor;
